{
  "selectAsField": "Pilih \"{value}\" sebagai {fieldName}",
  "typeToSearchField": "Ketik untuk mencari {fieldName}",
  "licenseFieldLabel": "Pilih Pelat Nomor (mis. 215BG2)",
  "licenseFieldName": "Pelat Nomor",
  "licensePlaceholder": "Cari berdasarkan pelat nomor",
  "dotFieldLabel": "Pilih Nomor DOT",
  "dotFieldName": "Nomor DOT",
  "dotPlaceholder": "Cari berdasarkan nomor DOT"
}
